import Button from '@carvana/ds-button';
import { CircleAlert } from 'lucide-react';
import { icon } from '@carvana/ds-styles';
import React from 'react';
import { EventedModal, ModalNames } from '|/app/modals';
import { AlertModalContent } from './alert-modal-content';

interface SlotUnavailableModalProps {
  isOpen: boolean;
  displayDate: string;
  displayTime: string;
  onSelectNewTime: () => void;
}

const SlotUnavailableModal: React.FC<SlotUnavailableModalProps> = ({
  isOpen,
  displayDate,
  displayTime,
  onSelectNewTime
}) => {
  const timeDescription = displayDate && displayTime ? `${displayDate} at ${displayTime}` : '';

  return (
    <EventedModal
      isOpen={isOpen}
      analyticsId={ModalNames.TimeSlotSubmissionError}
      zIndex={10000000}
      closeIcon={false}
      divLine={false}
      desktopWidth="480px"
      aria-labelledby="slot-unavailable-modal-title"
    >
      <AlertModalContent
        title="Time slot unavailable"
        titleId="slot-unavailable-modal-title"
        subtext={
          timeDescription
            ? `Your delivery time on ${timeDescription} is no longer available. Please select a new delivery time slot.`
            : 'Your delivery time is no longer available. Please select a new delivery time slot.'
        }
        icon={<CircleAlert size={24} color={icon.warning} />}
        action={
          <Button
            variant="primary"
            width="100%"
            onClick={onSelectNewTime}
            data-analytics-id="pp_checkout_slot_unavailable_select_new_time"
          >
            Select new time
          </Button>
        }
      />
    </EventedModal>
  );
};

export default SlotUnavailableModal;
